import type { EngineId, LanguageId } from '../constants';
import { NEXTGEN_NON_ENGLISH_NOTICE } from '../constants';

export interface EngineDescriptor {
  id: EngineId;
  label: string;
  tagline: string;
  multilingual: boolean;
}

export const ENGINES: EngineDescriptor[] = [
  {
    id: 'classic',
    label: 'Classic OCR',
    tagline: 'Tesseract LSTM · English, Hindi, Sanskrit and mixed pages',
    multilingual: true,
  },
  {
    id: 'nextgen',
    label: 'Next-Gen OCR',
    tagline: 'PaddleOCR PP-OCRv5 · English only in this app',
    multilingual: false,
  },
];

export function engineSupportsLanguage(engineId: EngineId, languageId: LanguageId): boolean {
  if (engineId === 'classic') return true;
  return languageId === 'english';
}

export interface EngineRoutingState {
  engineId: EngineId;
  nextGenDisabled: boolean;
  notice: string | null;
}

/**
 * Pure routing rule: non-English selections always fall back to Classic OCR
 * and lock Next-Gen OCR.
 */
export function routeEngine(requested: EngineId, languageId: LanguageId): EngineRoutingState {
  if (languageId !== 'english') {
    return { engineId: 'classic', nextGenDisabled: true, notice: NEXTGEN_NON_ENGLISH_NOTICE };
  }
  return { engineId: requested, nextGenDisabled: false, notice: null };
}
